export const PERMISSIONS = {
  CONTRAT: [
    { code: "CREATE_CONTRAT", label: "role.permission.CREATE_CONTRAT" },
    { code: "READ_CONTRAT", label: "role.permission.READ_CONTRAT" },
  ],
  INVOICE: [
    { code: "CREATE_INVOICE", label: "role.permission.CREATE_INVOICE" },
    { code: "READ_INVOICE", label: "role.permission.READ_INVOICE" },
    { code: "UPDATE_INVOICE", label: "role.permission.UPDATE_INVOICE" },
  ],
  QUOTE: [
    { code: "CREATE_QUOTE", label: "role.permission.CREATE_QUOTE" },
    { code: "READ_QUOTE", label: "role.permission.READ_QUOTE" },
    { code: "UPDATE_QUOTE", label: "role.permission.UPDATE_QUOTE" },
  ],
  SUPPLIER: [
    { code: "CREATE_SUPPLIER", label: "role.permission.CREATE_SUPPLIER" },
    {
      code: "READ_INVOICE_SUPPLIER",
      label: "role.permission.READ_INVOICE_SUPPLIER",
    },
    { code: "EDIT_SUPPLIER", label: "role.permission.EDIT_SUPPLIER" },
  ],
  CREDIT_NOTE: [
    { code: "CREATE_CREDIT_NOTE", label: "role.permission.CREATE_CREDIT_NOTE" },
    { code: "READ_CREDIT_NOTE", label: "role.permission.READ_CREDIT_NOTE" },
    { code: "UPDATE_CREDIT_NOTE", label: "role.permission.UPDATE_CREDIT_NOTE" },
    { code: "DELETE_CREDIT_NOTE", label: "role.permission.DELETE_CREDIT_NOTE" },
  ],
  EXPENSE: [
    { code: "CREATE_EXPENSE", label: "role.permission.CREATE_EXPENSE" },
    { code: "READ_EXPENSE", label: "role.permission.READ_EXPENSE" },
    { code: "EDIT_EXPENSE", label: "role.permission.UPDATE_EXPENSE" },
    { code: "DELETE_EXPENSE", label: "role.permission.DELETE_EXPENSE" },
  ],
  CLIENT: [
    { code: "CREATE_CLIENT", label: "role.permission.CREATE_CLIENT" },
    { code: "READ_CLIENT", label: "role.permission.READ_CLIENT" },
    { code: "EDIT_CLIENT", label: "role.permission.UPDATE_CLIENT" },
  ],
  OFFER: [
    { code: "CREATE_OFFER", label: "role.permission.CREATE_OFFER" },
    { code: "READ_OFFER", label: "role.permission.READ_OFFER" },
    { code: "UPDATE_OFFER", label: "role.permission.UPDATE_OFFER" },
    { code: "DELETE_OFFER", label: "role.permission.DELETE_OFFER" },
  ],
  USER: [
    { code: "CREATE_USER", label: "role.permission.CREATE_USER" },
    { code: "EDIT_USER", label: "role.permission.EDIT_USER" },
    { code: "READ_USER", label: "role.permission.READ_USER" },
  ],
  ROLE: [
    { code: "create_role", label: "role.permission.create_role" },
    { code: "edit_role", label: "role.permission.edit_role" },
    { code: "view_role", label: "role.permission.view_role" },
  ],
  PROJECT: [
    {
      code: "CREATE_PROJECT_ADMIN",
      label: "role.permission.CREATE_PROJECT_ADMIN",
    },
    { code: "PROJECT_ADMIN", label: "role.permission.PROJECT_ADMIN" },
    { code: "EDIT_PROJECT", label: "role.permission.EDIT_PROJECT" },
  ],
  OTHER: [
    { code: "SIGNATURE", label: "role.permission.SIGNATURE" },
    { code: "DOCUMENT", label: "role.permission.DOCUMENT" },
    { code: "CONFIGURATION", label: "role.permission.CONFIGURATION" },
    { code: "VALIDATEUR", label: "role.permission.VALIDATEUR" },
  ],
};
